import React from 'react';
import { AlertCircle } from 'lucide-react';

/** Inline validation message under a form field. Renders nothing when empty. */
export const FieldError: React.FC<{ message: string | undefined; id?: string }> = ({
  message,
  id
}) =>
  message ? (
    <p id={id} role='alert' className='text-xs text-destructive flex items-start gap-1'>
      <AlertCircle className='h-3 w-3 mt-0.5 shrink-0' /> {message}
    </p>
  ) : null;
